// helpers
import { axiosInstance } from "../helpers/axios/config";

// constants
import * as userEndPoints from "../constants/endPoints/user";
import * as method from "../constants/requestMethods";

// login user
export const loginUser = (user) => {
  return axiosInstance({
    url: userEndPoints.loginUser,
    method: method.POST,
    data: user,
  });
};

export const updateUserFcmId = (fcmId) => {
  return axiosInstance({
    url: userEndPoints.updateUserFcmId,
    method: method.POST,
    data: { fcmId },
  });
};

// logout user
export const logoutUser = () => {
  return axiosInstance({
    url: userEndPoints.logoutUser,
    method: method.GET,
  });
};

// change user password
export const changePassword = (data) => {
  return axiosInstance({
    url: userEndPoints.changePassword,
    method: method.PUT,
    data,
  });
};

// get all users
export const getAllUsers = (params) => {
  return axiosInstance({
    url: userEndPoints.getAllUsers,
    method: method.GET,
    params,
  });
};

export const getAllSalesUsers = (params) => {
  return axiosInstance({
    url: userEndPoints.GET_ALL_SALES_USERS,
    method: "GET",
    params,
  });
};

export const getSalesUser = (userId) => {
  return axiosInstance({
    url: userEndPoints.GET_SALES_USER.replace(":userId", userId),
    method: "GET",
  });
};

export const getUsersPhoneNumbers = () => {
  return axiosInstance({
    url: userEndPoints.GET_USERS_PHONE_NUMBERS,
    method: method.GET,
  });
};

// deactivate user
export const deactivateUser = (userId) => {
  return axiosInstance({
    url: `${userEndPoints.userSubDirectory}/${userId}/${userEndPoints.deactivateUser}`,
    method: method.PUT,
  });
};

// create user
export const createUser = (data) => {
  return axiosInstance({
    url: userEndPoints.createUser,
    method: method.POST,
    data,
  });
};

// validate user login 2-factor-auth
export const validate2fa = (data) => {
  return axiosInstance({
    url: userEndPoints.validate2fa,
    method: method.POST,
    data,
  });
};

// edit user
export const editUser = (userId, data) => {
  return axiosInstance({
    url: `${userEndPoints.userSubDirectory}/${userId}/${userEndPoints.editUser}`,
    method: method.PUT,
    data,
  });
};

export const getUserAccess = () => {
  return axiosInstance({
    url: userEndPoints.getUserAccess,
    method: method.GET,
  });
};

export const updateRoleAccess = (data) => {
  return axiosInstance({
    url: userEndPoints.updateRoleAccess,
    method: method.POST,
    data,
  });
};

export const getRoleList = () => {
  return axiosInstance({
    url: userEndPoints.getRoleList,
    method: method.GET,
  });
};

export const getSalesRoleList = () => {
  return axiosInstance({
    url: userEndPoints.GET_SALES_ROLE_LIST,
    method: "GET",
  });
};

export const getRoleAccess = (roleId) => {
  return axiosInstance({
    url: `${userEndPoints.getRoleAccess}/${roleId}`,
    method: method.GET,
  });
};

export const enable2fa = () => {
  return axiosInstance({
    url: userEndPoints.enable2fa,
    method: method.POST,
  });
};

export const check2faCode = (data) => {
  return axiosInstance({
    url: userEndPoints.check2faCode,
    method: method.POST,
    data,
  });
};

export const activateUser = (userId) => {
  return axiosInstance({
    url: `${userEndPoints.userSubDirectory}/${userId}/${userEndPoints.activateUser}`,
    method: method.PUT,
  });
};

export const getAllSkuSubCategoryApplicableUsers = () => {
  return axiosInstance({
    url: userEndPoints.getAllSkuSubCategoryApplicableUsers,
    method: method.GET,
  });
};

export const updateRoleSkuSubCategoryApplicable = (data) => {
  return axiosInstance({
    url: userEndPoints.updateRoleSkuSubCategoryApplicable,
    method: method.PUT,
    data,
  });
};

export const getAllCommercialMappingApplicableUsers = () => {
  return axiosInstance({
    url: userEndPoints.getAllCommercialMappingApplicableUsers,
    method: method.GET,
  });
};

export const updateRoleCommercialMappingApplicable = (data) => {
  return axiosInstance({
    url: userEndPoints.updateRoleCommercialMappingApplicable,
    method: method.PUT,
    data,
  });
};

export const getUsers = () => {
  return axiosInstance({
    url: userEndPoints.getUsers,
    method: method.GET,
  });
};

export const agentResetDeviceId = (agentId) => {
  return axiosInstance({
    url: userEndPoints.agentResetDeviceId.replace(":agentId", agentId),
    method: method.POST,
  });
};

export const getAllNegativeMarginApprovalUsers = () => {
  return axiosInstance({
    url: userEndPoints.getAllNegativeMarginApprovalUsers,
    method: method.GET,
  });
};

export const requestNegativeMarginOtp = (selectedUserId) => {
  return axiosInstance({
    url: userEndPoints.requestNegativeMarginOtp.replace(
      ":selectedUserId",
      selectedUserId
    ),
    method: method.PUT,
  });
};
